<template>


    <!-- HEADER -->
    <div class="card-header"
        style="padding-top: 12px; padding-right: 50px; background-color: transparent; display: flex; justify-content: space-between; align-items: center; z-index: 8; position: relative;">

        <button @click="closeChatBox" type="button"
                    class="btn btn-icon-only bg-transparent border-0 hp-hover-bg-black-10 hp-hover-bg-dark-100 hp-transition align-items-center justify-content-center dd-none"
                    style="height: 30px; position: absolute; left: 0px;">

                    <i class=" hp-text-color-dark-0  iconly-Curved-ChevronLeft hp-text-color-black-100 "
                        style="font-size: 18px;"></i>
        </button>

        <div class="col-12">

            

            <div class="row align-items-center" style="margin-left: 20px; padding-right: 0px; padding-top: 0px;"
                id="uInfo">

                
                
                <div class="w-auto px-0" @click="profileClick(currentPeerUser.userId, currentPeerUser.username)" style="cursor: pointer;">
                    <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle"
                        style="width: 38px; height: 38px; ">
                        <img :src="currentPeerUser.profilePic" class="hp-img-cover"
                            style="width: 38px; height: 38px; background-color: black; object-fit: cover; border-color: black; border-width: 1px; border-style: solid; ">
                    </div>
                </div>

                <div class="w-auto ms-8 px-0 mt-2">
                    <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleS"
                        style="width: 200px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis; margin-top: 5px; font-size: 12px;">{{
                            currentPeerUser.fullname }}


                        <!-- <span>
                                                                    <img src="@/assets/img/check-circle.png" alt="" width="15px"> 
                                                                </span>  -->

                    </span>
                    <span style="width: 200px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis; font-size: 11px;"
                        class="hp-badge-text fw-normal  hp-text-color-dark-30 mt-4">@{{ currentPeerUser.username
                        }}</span>


                </div>


            </div>

            <div class="hp-header-search col d-none" id="chatSearch">
                <input type="text" class="form-control" placeholder="Search chat..." id="header-search"
                    autocomplete="off">
            </div>

        </div>

        <div class="col-12">


            <button @click="searchOpen2" id="searchButton2" type="button"
                class="btn btn-icon-only bg-transparent border-0 hp-hover-bg-black-10 hp-hover-bg-dark-100 hp-transition d-flex align-items-center justify-content-center"
                style="height: 30px;">

                    <i class="hp-header-search-button-icon-2 hp-text-color-dark-0  ri-search-2-line hp-text-color-black-100"
                        style="font-size: 18px;"></i>

                </button>

                <button @click="searchClose2" id="searchButtonC2" type="button"
                    class="btn btn-icon-only bg-transparent border-0 hp-hover-bg-black-10 hp-hover-bg-dark-100 hp-transition d-flex align-items-center justify-content-center d-none"
                    style="height: 30px;">

                    <i class="hp-header-search-button-icon-2 hp-text-color-dark-0  ri-close-line hp-text-color-black-100 "
                        style="font-size: 18px;"></i>
                </button>


        </div>


    </div>

    <!-- input -->
    <div  style="position: absolute;  width: 100%; z-index: 9; border: none; border-radius: 0px;"
        class="card btmmm1">

        <div class="divider mt-8 mb-16"></div>

        <!-- media and tip box -->


        <div
            style="display: flex; justify-content: center; align-items: center;width: 100%; margin-top: 0px; position: relative;">

            <button class="btn btn-icon-only btn-sm rounded-circle btn-primary"
                style="width: 45px; height: 45px; position: absolute; left: 10px;" data-bs-toggle="dropdown">
                <i class="hp-text-color-dark-0 iconly-Light-Category"></i>
            </button>

            <ul class="dropdown-menu " style="cursor: pointer;">
                <li>
                    <div class="dropdown-item dp-hov"
                        style="display: flex; justify-content: center; align-items: center;" 
                        data-bs-target="#sendImage" data-bs-toggle="modal">
                        <span class="submenu-item-icon">
                            <i class="hp-text-color-dark-0 ri-2 ri-image-add-line" style="font-size: 20px;"></i>
                        </span>

                        <span
                            style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Attach
                            media</span>
                    </div>
                </li>

                <li>
                    <div class="divider mt-8 mb-6"></div>
                </li>

                <li>
                    <div class="dropdown-item dp-hov"
                        style="display: flex; justify-content: center; align-items: center;" data-bs-toggle="modal"
                        data-bs-target="#sendTip" >
                        <span class="submenu-item-icon rounded-circle">
                            <span
                                style="font-size: 12px; font-weight: 700; border-color: black; border-width: 2px; border-style: solid; border-radius: 50%; padding: 3px 6px;">&#8358;</span>
                        </span>
                        <span
                            style="text-align: start; width: 100%; padding-right: 50px; margin-top: 0px; margin-left: 10px;">Send
                            tip</span>
                    </div>
                </li>

            </ul>

            <textarea maxlength="300" cols="30" rows="2" class="form-control " placeholder="Type a message..."
                v-model="messageText"
                style=" padding: 5px 70px 5px 70px; width: 100%; line-height: normal; border-color: transparent;"></textarea>

            <button @click="sendTextMessage" class="btn btn-icon-only rounded-circle btn-primary"
                style="width: 45px; height: 45px; position: absolute; right: 10px;">
                <i class="hp-text-color-dark-0 iconly-Light-Send"></i>
            </button>

        </div>

        <!-- <div>
            <p class="hp-p1-body" style="text-align: center;">You cannot chat with this user because you are neither
                following them nor subscribed to them.</p>
        </div> -->


    </div>

    <!-- CHAT BODY -->
    <div class="card-body chatBac btmmm2"
        style="padding: 10px; overflow-y: scroll; overflow-x: hidden; cursor: pointer;  z-index: 8;  background-size: contain; background-position: center; background-repeat: repeat;">


        <div v-for="(message, index) in messageList" :key="'number' + index">

            <!-- FOR USER -->
            <div style="margin-top: 10px;" v-if="message.idFrom == myId">


                <!-- TIP -->
                <div class="col-10 col-md-9" style="margin-left: auto;" v-if="message.msgType == 'tip'">

                    <div
                        style=" width: fit-content; min-width: 300px; background-color: #28055b; padding: 15px; border-radius: 10px; border-top-right-radius: 0px; color: black; margin-bottom: 5px; margin-left: auto;">
                        
                        <div style="display: flex; justify-content: flex-start; align-items: center;">
                            <img src="../assets/img/tip.png" alt="" style="width: 40px; margin-right: 15px;">
                        
                            <h4 class="text-white" style="margin-top: 25px;"> <span>&#8358;</span> {{ message.tipD }} tip</h4>
                        </div>

                        <div class="divider mt-18 mb-16" style="opacity: 0.2; background-color: #fff;"></div>
                        <p class="hp-p1-body" style="color: #fff;"> {{ message.msg }} </p>

                        <p class="hp-p2-body"
                            style="font-size: 8px; text-align: end; padding: 0; margin: 0; color: #B7C2C5; ">
                            {{ message.date }}</p>
                    </div>


                </div>

                <!-- IMG -->
                <div class="col-10 col-md-9" style="margin-left: auto;" v-else-if="message.msgType == 'image'">

                    <div
                        style=" width: fit-content; min-width: 300px; background-color: #28055b; padding: 15px; border-radius: 10px; border-top-right-radius: 0px; color: black; margin-bottom: 5px; margin-left: auto;">

                        <div style="width: 100%; max-height: 400px; margin-bottom: 20px;">

                            <img :src="message.mediaUrl" alt=""
                                style="object-fit: cover; width: 100%; max-height:  400px;">

                        </div>

                        <h6 class="text-white">Sent an image ({{ message.mediaSize }})</h6>
                        <p class="hp-p1-body" style="color: #fff;"> {{ message.msg }} </p>

                        <p class="hp-p2-body"
                            style="font-size: 8px; text-align: end; padding: 0; margin: 0; color: #B7C2C5; ">
                            {{ message.date }}</p>
                    </div>


                </div>

                <!-- VID -->
                <div class="col-10 col-md-9" style="margin-left: auto;" v-else-if="message.msgType == 'video'">

                    <div
                        style=" width: fit-content; min-width: 300px; background-color: #28055b; padding: 15px; border-radius: 10px; border-top-right-radius: 0px; color: black; margin-bottom: 5px; margin-left: auto;">

                        <div style="width: 100%; max-height: 300px; margin-bottom: 20px;">

                            <video style="width: 100%; height: 300px; " controls controlsList="nodownload"
                                oncontextmenu="'false'">
                                <source :src="message.mediaUrl" type="video/mp4">
                                <source :src="message.mediaUrl" type="video/ogg">
                                <source :src="message.mediaUrl" type="video/webm">
                                <source :src="message.mediaUrl" type="video/3gp">
                                <source :src="message.mediaUrl" type="video/quicktime">
                                Your browser does not support the video tag.
                            </video>

                        </div>

                        <h6 class="text-white">Sent a video ({{ message.mediaSize }})</h6>
                        <p class="hp-p1-body" style="color: #fff;"> {{ message.msg }} </p>

                        <p class="hp-p2-body"
                            style="font-size: 8px; text-align: end; padding: 0; margin: 0; color: #B7C2C5; ">
                            {{ message.date }} </p>
                    </div>


                </div>

                <!-- TEXT -->
                <div class="col-10 col-md-9" style="margin-left: auto;" v-else-if="message.msgType == 'text'">

                    <div
                        style=" width: fit-content; background-color: #28055b; padding: 15px; border-radius: 10px; border-top-right-radius: 0px; color: white; margin-bottom: 5px; margin-left: auto;">
                        <p class="hp-p1-body" style="color: #fff;"> {{ message.msg }} </p>

                        <p class="hp-p2-body"
                            style="font-size: 8px; text-align: end; padding: 0; margin: 0; color: #B7C2C5;">
                            {{ message.date }} </p>
                    </div>


                </div>



            </div>

            <!-- FOR PEER -->
            <div style="margin-top: 10px;" v-else>


                <!-- TIP -->
                <div class="col-10 col-md-9" v-if="message.msgType == 'tip'">

                    <div
                        style=" width: fit-content; min-width: 300px; background-color: #F5F6FA; padding: 15px; border-radius: 10px; border-top-left-radius: 0px; color: black; margin-bottom: 5px;">

                        <div style="display: flex; justify-content: flex-start; align-items: center;">
                            <img src="../assets/img/tip2.png" alt="" style="width: 40px; margin-right: 15px;">
                        
                            <h4 class="text-black" style="margin-top: 25px;"> <span>&#8358;</span> {{ message.tipD }} tip</h4>
                        </div>

                        <div class="divider mt-18 mb-16" ></div>

                        <p class="hp-p1-body" style="color: #000;"> {{ message.msg }} </p>

                        <p class="hp-p2-body" style="font-size: 8px; text-align: start; padding: 0; margin: 0; ">{{
                            message.date }}</p>
                    </div>


                </div>

                <!-- IMG -->
                <div class="col-10 col-md-9" v-else-if="message.msgType == 'image'">

                    <div
                        style=" width: fit-content; min-width: 300px; background-color: #F5F6FA; padding: 15px; border-radius: 10px; border-top-left-radius: 0px; color: black; margin-bottom: 5px;">

                        <div style="width: 100%; max-height: 400px; margin-bottom: 20px;">

                            <img :src="message.mediaUrl" alt=""
                                style="object-fit: cover; width: 100%; max-height:  400px;">

                        </div>

                        <h6>Sent an image ({{ message.mediaSize }})</h6>

                        <p class="hp-p1-body" style="color: #000;"> {{ message.msg }} </p>

                        <p class="hp-p2-body" style="font-size: 8px; text-align: start; padding: 0; margin: 0; ">{{
                            message.date }}</p>
                    </div>


                </div>

                <!-- VID -->
                <div class="col-10 col-md-9" v-else-if="message.msgType == 'video'">

                    <div
                        style=" width: fit-content; min-width: 300px; background-color: #F5F6FA; padding: 15px; border-radius: 10px; border-top-right-radius: 0px; color: black; margin-bottom: 5px; ">

                        <div style="width: 100%; max-height: 300px; margin-bottom: 20px;">

                            <video style="width: 100%; height: 300px; " controls controlsList="nodownload"
                                oncontextmenu="'false'">
                                <source :src="message.mediaUrl" type="video/mp4">
                                <source :src="message.mediaUrl" type="video/ogg">
                                <source :src="message.mediaUrl" type="video/webm">
                                <source :src="message.mediaUrl" type="video/3gp">
                                <source :src="message.mediaUrl" type="video/quicktime">
                                Your browser does not support the video tag.
                            </video>

                        </div>

                        <h6>Sent a video ({{ message.mediaSize }})</h6>
                        <p class="hp-p1-body" style="color: #000;"> {{ message.msg }} </p>

                        <p class="hp-p2-body" style="font-size: 8px; text-align: start; padding: 0; margin: 0; ">{{
                            message.date }}</p>
                    </div>


                </div>

                <!-- TEXT -->
                <div class="col-10 col-md-9" v-else-if="message.msgType == 'text'">

                    <div
                        style=" width: fit-content; background-color: #F5F6FA; padding: 15px; border-radius: 10px; border-top-left-radius: 0px; color: black; margin-bottom: 5px;">
                        <p class="hp-p1-body" style="color: #000;"> {{ message.msg }} </p>

                        <p class="hp-p2-body" style="font-size: 8px; text-align: start; padding: 0; margin: 0; ">{{
                            message.date }}</p>
                    </div>


                </div>

            </div>




        </div>

        <div id="mainChatBox"></div>


    </div>

    <!-- SUCCESS -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="successModal">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 10px;">

                            <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{ successText }}</p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;"
                                @click="closeS">Okay</button>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ERROR -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg "
        ref="errorModal" id="errorModalChat">

        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 text-center">
                            <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto"
                                style=" width: 200px; padding-top: 30px;">

                            <h5 class="mt-24 mb-16 me-4 text-danger">Error!</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;" id="erText">{{ errorText }} </p>

                            <button class="btn btn-sm btn-primary"
                                style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;"
                                @click="closeE">Okay</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- LOADING -->
    <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg"
        ref="loadingModal" id="loadingModalChat">
        <div class="col-12 col-xl-4" style="width: 300px;">
            <div class="card hp-card-6">
                <div class="card-body">
                    <div class="row">

                        <div class="col-12 text-center">
                            <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;">
                        </div>

                        <div class="col-12 text-center">
                            <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                            <p class="hp-p1-body mb-0" style="margin-top: -10px;" id="mbLoadingText">{{ loadingText }}
                            </p>

                            <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- SEND TIP -->
    <div class="modal fade  " id="sendTip" tabindex="-1" aria-labelledby="sendTipLabel" aria-hidden="true" data-bs-backdrop="false" >
        <div class="modal-dialog modal-dialog-centered"  >
            <div class="modal-content" style="border-color:#000 ; border-width: 2px; border-style: dashed;">
                <div class="modal-header" >

                    <div class="w-auto px-0" >
                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                            <img :src="currentPeerUser.profilePic" class="hp-img-cover" style=" width: 48px; height: 48px;  background-color: black; object-fit: cover; border-color: #000; border-width: 1px; border-style: solid; pointer-events: all !important;">
                        </div>
                    </div>

                    <h4 class="modal-title" style="text-align: center; width: 100%;">Send Tip</h4>

                    <button type="button" style="z-index: 10;" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -40px;">

                    <!-- <p class="hp-p1-body">Send a token of appreciation to [model name]</p> -->

                    <form @submit.prevent="sendTipMessage">

                        <div class="mb-24" style="margin-top: 30px;">

                            <label for="displayName" class="form-label">Amount</label>
                            <div class="input-group mb-16">
                                <span class="input-group-text">&#8358;</span>
                                <input type="number" class="form-control" placeholder="100 to 50,000"
                                    aria-label="Username" aria-describedby="basic-addon1" required v-model="tip">
                            </div>

                        </div>

                        <div class="mb-24">

                            <label for="displayName" class="form-label">Message</label>
                            <textarea name="description" class="form-control" rows="4"
                                placeholder="Type a message here (optional)..."
                                style="line-height: 20px; padding-top: 10px;" v-model="messageTip"
                                maxlength="500"></textarea>

                        </div>

                        <div class="divider mt-18 mb-16"></div>



                        <div class="modal-footer d-flex justify-content-center">

                            <button class="btn btn-primary" data-bs-dismiss="modal">Confirm</button>
                        </div>

                    </form>







                </div>


            </div>
        </div>
    </div>

    

    <!-- SEND Media -->
    <div class="modal fade" id="sendImage" tabindex="-1" aria-labelledby="sendTipLabel" aria-hidden="true" data-bs-backdrop="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="border-color:#000 ; border-width: 2px; border-style: dashed;">
                <div class="modal-header">

                    <div class="w-auto px-0" >
                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                            <img :src="currentPeerUser.profilePic" class="hp-img-cover" style=" width: 48px; height: 48px;  background-color: black; object-fit: cover; border-color: #000; border-width: 1px; border-style: solid; pointer-events: all !important;">
                        </div>
                    </div>

                    <h4 class="modal-title" style="width: 100%; text-align: center;">Send Media </h4>

                    <button style="z-index: 10;" type="button" class="btn-close" data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>



                <div class="modal-body" style="margin-top: -40px;">

                    <!-- <p class="hp-p1-body">Send a token of appreciation to [model name]</p> -->

                    <form @submit.prevent="sendMediaMessage">

                        <div class="mb-24" style="margin-top: 30px; ">

                            <img src="" alt="." id="textMediaPre" class="d-none"
                                style="object-fit: cover; margin-right: 20px; width: 100%; height:  200px; border-radius: 10px;">

                            <video id="textMediaPre2" class="d-none" style="width: 100%; height: 200px; " controls
                                controlsList="nodownload" oncontextmenu="'false'">
                                <source src="" type="video/mp4">
                                <source src="" type="video/ogg">
                                <source src="" type="video/webm">
                                <source src="" type="video/3gp">
                                <source src="" type="video/quicktime">
                                Your browser does not support the video tag.
                            </video>

                        </div>

                        <div class="mb-24">

                            <input type="file" class="form-control" accept="video/*,image/*" id="textMediaSelect"
                                required @change="mediaPreview">
                            <div id="fileSizeText" class="form-text"><span> Max file size is 10(MB) for images and
                                    100(MB) for videos</span></div>

                        </div>

                        <div class="mb-24">

                            <label for="displayName" class="form-label">Message</label>
                            <textarea name="description" id="description" class="form-control" rows="4"
                                placeholder="Type a message here (optional)..."
                                style="line-height: 20px; padding-top: 10px;" v-model="messageMedia"
                                maxlength="500"></textarea>

                        </div>

                        <div class="divider mt-18 mb-16"></div>



                        <div class="modal-footer d-flex justify-content-center">

                            <button class="btn btn-primary" data-bs-dismiss="modal">Confirm</button>
                        </div>

                    </form>







                </div>


            </div>
        </div>
    </div>

</template>


<script>

import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
import "../../node_modules/v3-infinite-loading/lib/style.css";

import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';

import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, setDoc, onSnapshot, Timestamp } from "firebase/firestore";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth"
import { db } from '@/firebase';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import axios from 'axios';

import Compressor from 'compressorjs';

export default {

    components: {
        InfiniteLoading,
    },

    props: ["currentPeerUser"],

    data() {
        return {
            loadingText: "",
            errorText: "",
            successText: "",
            blobUrl: "",
            userName: "",
            textMediaUrl: "",
            groupChatId: null,
            messageText: "",

            messageMedia: "",
            fileSize: "",

            tip: "",
            messageTip: "",

            messageList: [],
            followingList: [],
            subList: [],

            myId: "",

            unsub1: null,
            unsub2: null,

            subscribed: false,
            following: false,
            fan: false,

            userType: "",

            
            upline: "",
            uplineUserId: "",
            refCut: "",
            dateJoined: "",
            sexuality: "",
            modelEmail:"",

        }
    },

    watch: {

        currentPeerUser: function (newVal, oldVal) {
            if (newVal !== oldVal) {

                this.getMessages();
                setTimeout(this.goTop, 2000);

            }
        }

    },

    beforeUnmount() {

        if (this.unsub1 != null) {
            this.unsub1();
        }
        if (this.unsub2 != null) {
            this.unsub2();
        }

        this.subscribed = false;
        this.following = false;

    },

    mounted() {

        

        this.myId = getAuth().currentUser.uid;
        this.getUserInfo();
        this.getMessages();
        this.getFollowing();
        this.getSubs();
        this.getFans();
        setTimeout(this.goTop, 2000);
        //this.$refs.errorModal.classList.add("bg-active"); 

        this.onBackp();

        this.getRefCut();
        
    },

    methods: {

        closeE() {
            this.$refs.errorModal.classList.remove("bg-active");
        },

        closeS() {
            this.$refs.successModal.classList.remove("bg-active");
            //this.$router.go();
        },

        detectMob() {
            return ( ( window.innerWidth <= 600 ) );
        },

        async getRefCut(){
            const userRef = doc(db, "AdminInfo", "info");
            const userSnap = await getDoc(userRef);
            let rc = userSnap.data().refCut;
            this.refCut = Number(rc);

        },

        goTop() {

            let contanier = document.getElementById("mainChatBox");
            if (contanier != null) {
                contanier.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }

        },

        onBackp(){
            window.onpopstate = () => {
                if(this.detectMob()){
                    this.$router.push({name: 'messages'});
                }
            };
        },

        async getUserInfo(){
            const auth = getAuth();
            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if(userSnap.exists()){
                this.userType = userSnap.data().type;
            }
        },

        closeChatBox(){

            if(this.detectMob()){

                document.getElementById("userListBox").style.display = "block";
                document.getElementById("chatBox").classList.add("mm-none");
                document.getElementById("headerBox").style.display = "block";
                document.getElementById("addBtnMobile").style.display = "block";

            }

        },

        async getFollowing() {
            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserFollowing", auth.currentUser.uid, "Following"));
            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {
                    if (this.currentPeerUser.userId == doc.id) {
                        this.following = true;
                        return;
                    }
                })

            }

        },

        async getSubs() {
            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserSubs", auth.currentUser.uid, "Subs"));
            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {
                    if (this.currentPeerUser.userId == doc.id) {
                        this.subscribed = true;
                        return;
                    }
                })

            }
        },

        async getFans() {
            const auth = getAuth();
            const querySnapshot = await getDocs(collection(db, "UserFans", auth.currentUser.uid, "Fans"));
            if (querySnapshot.docs.length > 0) {

                querySnapshot.forEach((doc) => {
                    if (this.currentPeerUser.userId == doc.id) {
                        this.fan = true;
                        return;
                    }
                })

            }
        },

        profileClick(userId, username) {

            const auth = getAuth();

            if (auth.currentUser.uid == userId) {
                this.$router.push({ name: 'profile' });
                return;
            }

            sessionStorage.setItem("otherId", userId);
            this.$router.push({ name: 'other-profile', params: { id: username } });
            return;




        },

        searchOpen() {

            document.getElementById("userSearch").classList.remove("d-none");
            document.getElementById("searchButtonC").classList.remove("d-none");
            document.getElementById("convoTitle").classList.add("d-none");
            document.getElementById("searchButton").classList.add("d-none");

        },

        searchClose() {

            document.getElementById("userSearch").classList.add("d-none");
            document.getElementById("searchButtonC").classList.add("d-none");
            document.getElementById("convoTitle").classList.remove("d-none");
            document.getElementById("searchButton").classList.remove("d-none");

        },

        searchOpen2() {

            document.getElementById("chatSearch").classList.remove("d-none");
            document.getElementById("searchButtonC2").classList.remove("d-none");
            document.getElementById("uInfo").classList.add("d-none");
            document.getElementById("searchButton2").classList.add("d-none");

        },

        searchClose2() {

            document.getElementById("chatSearch").classList.add("d-none");
            document.getElementById("searchButtonC2").classList.add("d-none");
            document.getElementById("uInfo").classList.remove("d-none");
            document.getElementById("searchButton2").classList.remove("d-none");

        },

        blobTest() {
            let blob = new Blob(["https://www.omcdex.io/img/decentraWallet1.09b3d76e.png"], { type: 'text/plain' });

            this.blobUrl = URL.createObjectURL(blob);
        },

        getOccurrence(array, value) {
            var count = 0;
            array.forEach((v) => (v === value && count++));
            return count;
        },

        mediaPreview() {

            if (document.getElementById("textMediaSelect").files[0] == null) {
                document.getElementById("textMediaPre").classList.add("d-none");
                document.getElementById("textMediaPre2").classList.add("d-none");
                return;
            }

            const fileReader = new FileReader();

            fileReader.readAsDataURL(document.getElementById("textMediaSelect").files[0]);
            fileReader.addEventListener("load", function () {

                if (document.getElementById("textMediaSelect").files[0].type.startsWith("video")) {
                    document.getElementById("textMediaPre").classList.add("d-none");
                    document.getElementById("textMediaPre2").src = this.result;
                    document.getElementById("textMediaPre2").classList.remove("d-none");
                }
                else {
                    document.getElementById("textMediaPre").classList.add("d-none");
                    document.getElementById("textMediaPre").src = this.result;
                    document.getElementById("textMediaPre").classList.remove("d-none");
                }

            });

            if (Number(document.getElementById("textMediaSelect").files[0].size) >= 1073741824) {
                this.fileSize = (Number(document.getElementById("textMediaSelect").files[0].size) / 1073741824).toFixed(2) + " GB";
            }
            else if (Number(document.getElementById("textMediaSelect").files[0].size) >= 1048576) {
                this.fileSize = (Number(document.getElementById("textMediaSelect").files[0].size) / 1048576).toFixed(2) + " MB";
            }
            else if (Number(document.getElementById("textMediaSelect").files[0].size) >= 1024) {
                this.fileSize = (Number(document.getElementById("textMediaSelect").files[0].size) / 1024).toFixed(2) + " KB";
            }

        },

        uploadMediaFile() {

            let content = this.messageMedia.trim();
            let ldText = document.getElementById("mbLoadingText");
            let erText = document.getElementById("erText");
            let loadingModalChat = document.getElementById("loadingModalChat");
            let errorModalChat = document.getElementById("errorModalChat");
            sessionStorage.setItem("content", content);
            this.messageMedia = "";
            this.loadingText = "";
            this.errorText = "";


            sessionStorage.setItem("groupChatId", this.groupChatId);
            sessionStorage.setItem("idTo", this.currentPeerUser.userId);
            sessionStorage.setItem("fileSize", this.fileSize);

            return new Promise(function (resolve, reject) {

                const storage = getStorage();
                let media = document.getElementById("textMediaSelect").files[0];

                if (media.type.startsWith("image")) {

                    new Compressor(media, {
                        quality: 0.6,
                        width: 1024,
                        // The compression process is asynchronous,
                        // which means you have to access the `result` in the `success` hook function.
                        success(result) {

                            const storageRef = ref(storage, 'UserMessages/' + sessionStorage.getItem("groupChatId") + '/Images/' + result.name);
                            const uploadTask = uploadBytesResumable(storageRef, result);

                            uploadTask.on('state_changed',
                                (snapshot) => {
                                    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                    ldText.textContent = "Uploading image file (" + progress + "%)....";
                                    // console.log('Upload is ' + progress + '% done');
                                    switch (snapshot.state) {
                                        case 'paused':
                                            //console.log('Upload is paused');
                                            break;
                                        case 'running':
                                            //console.log('Upload is running');
                                            break;
                                    }
                                },
                                (error) => {
                                    switch (error.code) {
                                        case 'storage/unauthorized':
                                            // User doesn't have permission to access the object
                                            break;
                                        case 'storage/canceled':
                                            // User canceled the upload
                                            break;
                                        case 'storage/unknown':
                                            // Unknown error occurred, inspect error.serverResponse
                                            erText.textContent = "Unknown error occured";
                                            loadingModalChat.classList.remove("bg-active");
                                            errorModalChat.classList.add("bg-active");
                                            console.log(error.serverResponse);
                                            return;
                                            break;
                                    }
                                },
                                () => {
                                    // Upload completed successfully, now we can get the download URL
                                    getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                        const auth = getAuth();
                                        let timeStamp = new Date().getTime() / 1000;

                                        let mSecs = new Date().getTime() / 1000;
                                        let secs = 10000000000 / mSecs

                                        await setDoc(doc(db, "UserMessages", sessionStorage.getItem("groupChatId"), "Messages", String(timeStamp)), {
                                            id: timeStamp,
                                            idTo: sessionStorage.getItem("idTo"),
                                            idFrom: auth.currentUser.uid,
                                            msgType: "image",
                                            msgTitle: "",
                                            msg: sessionStorage.getItem("content"),
                                            mediaUrl: downloadURL,
                                            mediaSize: sessionStorage.getItem("fileSize"),
                                            read: false,
                                            tip: 0,
                                            timeStamp: serverTimestamp(),
                                            timeStampN: secs

                                        });



                                        setTimeout(resolve, 2000);

                                    });
                                });



                        },
                        error(err) {
                            console.log(err.message);
                            return;
                        },
                    });

                }
                else {

                    const storageRef = ref(storage, 'UserMessages/' + sessionStorage.getItem("groupChatId") + '/Videos/' + media.name);
                    const uploadTask = uploadBytesResumable(storageRef, media);
                    //Update progress bar
                    uploadTask.on('state_changed',
                        (snapshot) => {
                            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                            ldText.textContent = "Uploading video file (" + progress + "%)....";
                            // console.log('Upload is ' + progress + '% done');
                            switch (snapshot.state) {
                                case 'paused':
                                    //console.log('Upload is paused');
                                    break;
                                case 'running':
                                    //console.log('Upload is running');
                                    break;
                            }
                        },
                        (error) => {
                            switch (error.code) {
                                case 'storage/unauthorized':
                                    // User doesn't have permission to access the object
                                    break;
                                case 'storage/canceled':
                                    // User canceled the upload
                                    break;
                                case 'storage/unknown':
                                    // Unknown error occurred, inspect error.serverResponse
                                    erText.textContent = "Unknown error occured";
                                    loadingModalChat.classList.remove("bg-active");
                                    errorModalChat.classList.add("bg-active");
                                    console.log(error.serverResponse);
                                    return;
                                    break;
                            }
                        },
                        () => {
                            // Upload completed successfully, now we can get the download URL
                            getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                const auth = getAuth();
                                let timeStamp = new Date().getTime() / 1000;

                                await setDoc(doc(db, "UserMessages", sessionStorage.getItem("groupChatId"), "Messages", String(timeStamp)), {
                                    id: timeStamp,
                                    idTo: sessionStorage.getItem("idTo"),
                                    idFrom: auth.currentUser.uid,
                                    msgType: "video",
                                    msgTitle: "",
                                    msg: sessionStorage.getItem("content"),
                                    mediaUrl: downloadURL,
                                    mediaSize: sessionStorage.getItem("fileSize"),
                                    read: false,
                                    tip: 0,
                                    timeStamp: serverTimestamp(),

                                });

                                setTimeout(resolve, 2000);

                            });
                        });

                }

            });



        },

        async sendTextMessage() {

            if (this.userType == "user" && !this.subscribed && !this.fan) {
                this.errorText = "You cannot chat with this user because you are not subscribed to them.";
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            if (this.messageText.trim() == "") {
                return;
            }

            const auth = getAuth();
            let content = this.messageText.trim();
            let timeStamp = new Date().getTime() / 1000;
            this.messageText = "";

            let mSecs = new Date().getTime() / 1000;
            let secs = 10000000000 / mSecs

            await setDoc(doc(db, "UserMessages", this.groupChatId, "Messages", String(timeStamp)), {
                id: timeStamp,
                idTo: this.currentPeerUser.userId,
                idFrom: auth.currentUser.uid,
                msgType: "text",
                msgTitle: "",
                msg: content,
                mediaUrl: "",
                mediaSize: "",
                read: false,
                tip: 0,
                timeStamp: serverTimestamp(),
                timeStampN: secs

            });

            //UPDATE LASTMSG
            const convoRef1 = doc(db, "UserConvo", auth.currentUser.uid, "UserList", this.currentPeerUser.userId);
            await updateDoc(convoRef1, {
                userId: this.currentPeerUser.userId,
                fullname: this.currentPeerUser.fullname,
                username: this.currentPeerUser.username,
                profilePic: this.currentPeerUser.profilePic,
                lastMsg: content,
                lastMsgType: "text",
                lastTimestampSecs: Timestamp.now().seconds,
                lastTimestamp: serverTimestamp(),
                unreadCount: 0,
                blocked: "false",
                tipAmount: 0,
            });

            const convoRef2 = doc(db, "UserConvo", this.currentPeerUser.userId, "UserList", auth.currentUser.uid);
            await updateDoc(convoRef2, {
                userId: auth.currentUser.uid,
                fullname: sessionStorage.getItem("fullName"),
                username: sessionStorage.getItem("userName"),
                profilePic: sessionStorage.getItem("profilePic"),
                lastMsg: content,
                lastMsgType: "text",
                lastTimestamp: serverTimestamp(),
                lastTimestampSecs: Timestamp.now().seconds,
                unreadCount: increment(1),
                blocked: "false",
                tipAmount: 0,
            });

            const userRef = doc(db, "Users", this.currentPeerUser.userId);
            await updateDoc(userRef, {
                msgList: arrayUnion(auth.currentUser.uid)
            });

            this.goTop();

        },

        async sendMediaMessage() {

            this.loadingText = "Uploading file...";
            this.$refs.loadingModal.classList.add("bg-active");

            if (this.userType == "user" && !this.subscribed && !this.fan) {
                this.errorText = "You cannot chat with this user because you are not subscribed to them.";
                this.$refs.errorModal.classList.add("bg-active");
                this.$refs.loadingModal.classList.remove("bg-active");
                return;
            }

            const auth = getAuth();

            let media = document.getElementById("textMediaSelect").files[0];
            let mediaType = media.type;
            let mediaSize = Number(media.size);
            let content = this.messageMedia.trim();

            if (mediaType.startsWith("image")) {

                if (mediaSize > 10971520) {
                    this.errorText = "The image is too large. Maximum size for images is 10 MB. Please select a new image to proceed.";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

            }

            else {

                if (mediaSize > 124288000) {
                    this.errorText = "The video is too large. Maximum size for videos is 100 MB. Please select a new video to proceed.";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

            }

            await this.uploadMediaFile();

            const convoRef1 = doc(db, "UserConvo", auth.currentUser.uid, "UserList", this.currentPeerUser.userId);
            await updateDoc(convoRef1, {
                userId: this.currentPeerUser.userId,
                fullname: this.currentPeerUser.fullname,
                username: this.currentPeerUser.username,
                profilePic: this.currentPeerUser.profilePic,
                lastMsg: content,
                lastMsgType: mediaType,
                lastTimestampSecs: Timestamp.now().seconds,
                lastTimestamp: serverTimestamp(),
                unreadCount: 0,
                blocked: "false",
                tipAmount: 0,
            });

            const convoRef2 = doc(db, "UserConvo", this.currentPeerUser.userId, "UserList", auth.currentUser.uid);
            await updateDoc(convoRef2, {
                userId: auth.currentUser.uid,
                fullname: sessionStorage.getItem("fullName"),
                username: sessionStorage.getItem("userName"),
                profilePic: sessionStorage.getItem("profilePic"),
                lastMsg: content,
                lastMsgType: mediaType,
                lastTimestamp: serverTimestamp(),
                lastTimestampSecs: Timestamp.now().seconds,
                unreadCount: increment(1),
                blocked: "false",
                tipAmount: 0,
            });

            const userRef = doc(db, "Users", this.currentPeerUser.userId);
            await updateDoc(userRef, {
                msgList: arrayUnion(auth.currentUser.uid)
            });

            this.goTop();

            this.successText = "The file was uploaded successfully";
            this.$refs.loadingModal.classList.remove("bg-active");
            this.$refs.successModal.classList.add("bg-active");

        },

        async sendTipMessage() {

            let balance, newBalance, uFullname, uUsername, uEmail, uProfilePic;

            if (this.tip < 100) {
                this.errorText = "Minimum amount for tips is ₦ 100.";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            if (this.tip > 500000) {
                this.errorText = "Maximum amount for tips is ₦ 500,000 ";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.errorModal.classList.add("bg-active");
                return;
            }

            this.loadingText = "Sending tip...";
            this.$refs.loadingModal.classList.add("bg-active");


            //check balance
            const auth = getAuth();
            const userRef = doc(db, "Users", auth.currentUser.uid);
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                balance = userSnap.data().balance;
                uUsername = userSnap.data().displayId;
                uFullname = userSnap.data().name,
                uProfilePic = userSnap.data().profilePic;
                uEmail = userSnap.data().email;

                if (balance < this.tip) {
                    this.errorText = "Insufficient balance. Please top up your account and try again.";
                    this.$refs.errorModal.classList.add("bg-active");
                    this.$refs.loadingModal.classList.remove("bg-active");
                    return;
                }
            }
            else {
                this.$router.push({ name: 'sign-in' });
                return;
            }

            newBalance = balance - this.tip;

            await updateDoc(userRef, {
                balance: newBalance,
            });

            const modelRef = doc(db, "Users", this.currentPeerUser.userId);
            await updateDoc(modelRef, {
                earnings: increment(this.tip),
                tipBalance: increment(this.tip),
                notiCount: increment(1),
                msgList: arrayUnion(auth.currentUser.uid)
            });

            let mSecs = new Date().getTime() / 1000;
            let transSecs = 10000000000 / mSecs

            //update user transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBW" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Withdrawal",
                title: "Sent tip",
                description: " Sent a tip of ₦ " + this.tip + " to @" + this.currentPeerUser.username,
                amount: this.tip,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: auth.currentUser.uid,
                
                fullName: this.currentPeerUser.fullname,
                username: this.currentPeerUser.username,
                profilePic: this.currentPeerUser.profilePic,
            });

            //update model transactions
            await addDoc(collection(db, "UserTrans"), {
                idD: "FBD" + Math.floor(1000000 + Math.random() * 9000000),
                type: "Deposit",
                title: "Received tip",
                description: "@" + uUsername + " sent a tip of ₦ " + this.tip + " ",
                amount: this.tip,
                method: "Baesnap Wallet",
                date: serverTimestamp(),
                dateN: transSecs,
                status: "successful",
                userId: this.currentPeerUser.userId,
                username: uUsername,
                fullName: uFullname,
                profilePic: uProfilePic,
                
            });

            // NOTIFICATION
            if (this.currentPeerUser.userId != auth.currentUser.uid) {

                let mSecs = new Date().getTime()/1000;
                let secs = 10000000000 / mSecs

                await addDoc(collection(db, "UserNoti"), {
                    category: "Tips",
                    description: "Sent you a tip of ₦ " + this.tip,
                    ownerId: this.currentPeerUser.userId,
                    userId: auth.currentUser.uid,
                    username: uUsername,
                    fullName: uFullname,
                    profilePic: uProfilePic,
                    email: uEmail,
                    date: serverTimestamp(),
                    dateN: secs,
                    postId: "",
                });

            }


            //SEND TIP MESSAGE
            let content = this.messageTip.trim();
            let timeStamp = new Date().getTime() / 1000;
            this.messageTip = "";

            

            await setDoc(doc(db, "UserMessages", this.groupChatId, "Messages", String(timeStamp)), {
                id: timeStamp,
                idTo: this.currentPeerUser.userId,
                idFrom: auth.currentUser.uid,
                msgType: "tip",
                msgTitle: "",
                msg: content,
                mediaUrl: "",
                mediaSize: "",
                read: false,
                tip: this.tip,
                timeStamp: serverTimestamp(),
                timeStampN: transSecs,

            });

            //UPDATE LASTMSG

            const convoRef1 = doc(db, "UserConvo", auth.currentUser.uid, "UserList", this.currentPeerUser.userId);
            await updateDoc(convoRef1, {
                userId: this.currentPeerUser.userId,
                fullname: this.currentPeerUser.fullname,
                username: this.currentPeerUser.username,
                profilePic: this.currentPeerUser.profilePic,
                lastMsg: content,
                lastMsgType: "tip",
                lastTimestampSecs: Timestamp.now().seconds,
                lastTimestamp: serverTimestamp(),
                unreadCount: 0,
                blocked: "false",
                tipAmount: this.tip,
            });

            const convoRef2 = doc(db, "UserConvo", this.currentPeerUser.userId, "UserList", auth.currentUser.uid);
            await updateDoc(convoRef2, {
                userId: auth.currentUser.uid,
                fullname: sessionStorage.getItem("fullName"),
                username: sessionStorage.getItem("userName"),
                profilePic: sessionStorage.getItem("profilePic"),
                lastMsg: content,
                lastMsgType: "tip",
                lastTimestamp: serverTimestamp(),
                lastTimestampSecs: Timestamp.now().seconds,
                unreadCount: increment(1),
                blocked: "false",
                tipAmount: this.tip,
            });

            this.goTop();

            let content2 = content;
            if(content == ""){
                content2 = "none";
            }

            const peerRef = doc(db, "Users", this.currentPeerUser.userId);
            const peerSnap = await getDoc(peerRef);

                    this.dateJoined = peerSnap.data().dateJoined.seconds;
                    this.upline = peerSnap.data().upline;
                    this.sexuality = peerSnap.data().sexuality;
                    this.userType = peerSnap.data().type;
                    this.modelEmail = peerSnap.data().email;

                axios.post('https://api.baesnap.com/v1/tip-mail', {
                    toName: this.currentPeerUser.fullname,
                    toEmail: peerSnap.data().email,
                    username: peerSnap.data().displayId,
                    amount: Number(this.tip).toLocaleString("us-Us"),
                    message: content2
                })
                .then(function (response) {
                    console.log(response);
                    
                })

            //REFF
            //check ref endDate

            const q = query(collection(db, "Users"), where("refCode", "==", this.upline));
            const idSnapshot = await getDocs(q);
            if(idSnapshot.docs.length > 0){
                idSnapshot.forEach((doc) => {
                    this.uplineUserId = doc.id;
                });

            }

            let dateJoinedMili = Number(this.dateJoined) * 1000;
            let todayMili = Timestamp.now().seconds * 1000;

            let refDays = Math.round((todayMili - dateJoinedMili) / (1000 * 60 * 60 * 24));

            if(Number(refDays) < 365 && this.upline != ""){

                    if(this.uplineUserId == auth.currentUser.uid){
                        this.successText = "Tip sent successfully";
                        this.$refs.successModal.classList.add("bg-active");
                        this.$refs.loadingModal.classList.remove("bg-active");
                        return;
                    }

                    //update upline ref balance
                    let mRefCut = this.refCut/100;
                    let refAmount = Number(this.tip) * mRefCut;

                    const usersRef = doc(db, "Users", this.uplineUserId);
                    await updateDoc(usersRef, {
                        
                        refBalance: increment(refAmount),
                        
                    });

                    //update upline ref user
                    const refUserRef = doc(db, "Referrals", this.currentPeerUser.userId);
                    await updateDoc(refUserRef, {
                        
                        refBalance: increment(refAmount),
                        
                    });

                    let mSecs = Timestamp.now().seconds;
                    let secs = 10000000000 / mSecs;
                    
                    //update upline refTrans
                    await addDoc(collection(db, "RefTrans"), {
                        type: "Deposit",
                        refAmount: refAmount,

                        fullName: this.currentPeerUser.fullname,
                        userName: this.currentPeerUser.username,
                        profilePic: this.currentPeerUser.profilePic,
                        email: this.modelEmail,
                        userType: this.userType,
                        sexuality: this.sexuality,
                        userId: this.currentPeerUser.userId,
                        timeStamp: serverTimestamp(),
                        timeStampN: secs,

                        status: "successful",
                        ownerId: this.uplineUserId
                    });

                }

            this.successText = "Tip sent successfully";
            this.$refs.successModal.classList.add("bg-active");
            this.$refs.loadingModal.classList.remove("bg-active");

        },

        async getMessages() {

            this.messageList = [];

            if (this.unsub1 != null) {
                this.unsub1();
            }
            if (this.unsub2 != null) {
                this.unsub2();
            }

            const auth = getAuth();

            let groupChatId = `${this.currentPeerUser.userId} + ${auth.currentUser.uid}`;

            const q = query(collection(db, "UserMessages", groupChatId, "Messages"));

            this.unsub1 = onSnapshot(q, async (snapshot) => {

                if (snapshot.docChanges().length > 0) {

                    this.groupChatId = groupChatId;

                    snapshot.docChanges().forEach((res) => {

                        if (res.type === "added") {
                            let a = String(new Date(Number(res.doc.data().id) * 1000));

                            this.messageList.push({

                                id: res.doc.data().id,
                                idTo: res.doc.data().idTo,
                                idFrom: res.doc.data().idFrom,
                                msgType: res.doc.data().msgType,
                                msgTitle: res.doc.data().msgTitle,
                                msg: res.doc.data().msg,
                                mediaUrl: res.doc.data().mediaUrl,
                                mediaSize: res.doc.data().mediaSize,
                                read: res.doc.data().read,
                                tip: res.doc.data().tip,
                                tipD: Number(res.doc.data().tip).toLocaleString("us-US"),
                                timeStamp: res.doc.data().timeStamp,
                                date: a.slice(0, -36),

                            })

                            this.goTop();
                        }

                    });

                }
                else {

                    this.groupChatId = `${auth.currentUser.uid} + ${this.currentPeerUser.userId}`;
                    const q = query(collection(db, "UserMessages", this.groupChatId, "Messages")
                    );

                    this.unsub2 = onSnapshot(q, (snapshot) => {

                        snapshot.docChanges().forEach((res) => {
                            if (res.type === "added") {

                                let a = String(new Date(Number(res.doc.data().id) * 1000));

                                this.messageList.push({

                                    id: res.doc.data().id,
                                    idTo: res.doc.data().idTo,
                                    idFrom: res.doc.data().idFrom,
                                    msgType: res.doc.data().msgType,
                                    msgTitle: res.doc.data().msgTitle,
                                    msg: res.doc.data().msg,
                                    mediaUrl: res.doc.data().mediaUrl,
                                    mediaSize: res.doc.data().mediaSize,
                                    read: res.doc.data().read,
                                    tip: res.doc.data().tip,
                                    tipD: Number(res.doc.data().tip).toLocaleString("us-US"),
                                    timeStamp: res.doc.data().timeStamp,
                                    date: a.slice(0, -36),

                                })

                                this.goTop();

                            }

                        });
                    });

                }


            });

        },

    },

}

</script>